import { KMutableProperty11e8g1gb0ecb9j as KMutableProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { pipelineContextFor1bwb6ae3xig1h as pipelineContextFor } from './PipelineContext.mjs';
import { PhaseContent20yhla4zqpd2q as PhaseContent } from './PhaseContent.mjs';
import {
  Last_getInstance2u4trukmqn9e4 as Last_getInstance,
  After9djz11pmyzvq as After,
  Beforeyqm571m7tesc as Before,
} from './PipelinePhaseRelation.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  mutableListOf6oorvk2mtdmp as mutableListOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  anyToString3ho3k49fc56mj as anyToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { last1vo29oleiqj36 as last } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../Attributes.web.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { InvalidPhaseExceptionxbo9a9gosqf3 as InvalidPhaseException } from './PipelinePhase.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _set_interceptors__wod97b($this, _set____db54di) {
  var tmp0 = $this.interceptors$delegate_1;
  var tmp = KMutableProperty1();
  var tmp_0 = Pipeline$_get_interceptors_$ref_u6zl4e();
  // Inline function 'kotlinx.atomicfu.AtomicRef.setValue' call
  getPropertyCallableRef('interceptors', 1, tmp, tmp_0, Pipeline$_set_interceptors_$ref_13vc1m());
  tmp0.kotlinx$atomicfu$value = _set____db54di;
  return Unit_instance;
}
function _get_interceptors__h4min7($this) {
  var tmp0 = $this.interceptors$delegate_1;
  var tmp = KMutableProperty1();
  var tmp_0 = Pipeline$_get_interceptors_$ref_u6zl4e();
  // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
  getPropertyCallableRef('interceptors', 1, tmp, tmp_0, Pipeline$_set_interceptors_$ref_13vc1m());
  return tmp0.kotlinx$atomicfu$value;
}
function createContext($this, context, subject, coroutineContext) {
  return pipelineContextFor(context, sharedInterceptorsList($this), subject, coroutineContext, $this.get_developmentMode_eqiro5_k$());
}
function findPhase($this, phase) {
  var phasesList = $this.phasesRaw_1;
  var inductionVariable = 0;
  var last = phasesList.get_size_woubt6_k$();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var current = phasesList.get_c1px32_k$(index);
      if (current === phase) {
        var content = PhaseContent().new_io_ktor_util_pipeline_PhaseContent_24bg4y_k$(phase, Last_getInstance());
        phasesList.set_82063s_k$(index, content);
        return content;
      }
      var tmp;
      if (current instanceof PhaseContent()) {
        tmp = current.phase_1 === phase;
      } else {
        tmp = false;
      }
      if (tmp) {
        return current instanceof PhaseContent() ? current : THROW_CCE();
      }
    }
     while (inductionVariable < last);
  return null;
}
function findPhaseIndex($this, phase) {
  var phasesList = $this.phasesRaw_1;
  var inductionVariable = 0;
  var last = phasesList.get_size_woubt6_k$();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var current = phasesList.get_c1px32_k$(index);
      var tmp;
      if (current === phase) {
        tmp = true;
      } else {
        var tmp_0;
        if (current instanceof PhaseContent()) {
          tmp_0 = current.phase_1 === phase;
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        return index;
      }
    }
     while (inductionVariable < last);
  return -1;
}
function hasPhase($this, phase) {
  var phasesList = $this.phasesRaw_1;
  var inductionVariable = 0;
  var last = phasesList.get_size_woubt6_k$();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var current = phasesList.get_c1px32_k$(index);
      var tmp;
      if (current === phase) {
        tmp = true;
      } else {
        var tmp_0;
        if (current instanceof PhaseContent()) {
          tmp_0 = current.phase_1 === phase;
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        return true;
      }
    }
     while (inductionVariable < last);
  return false;
}
function cacheInterceptors($this) {
  var interceptorsQuantity = $this.interceptorsQuantity_1;
  if (interceptorsQuantity === 0) {
    notSharedInterceptorsList($this, emptyList());
    return emptyList();
  }
  var phases = $this.phasesRaw_1;
  if (interceptorsQuantity === 1) {
    var inductionVariable = 0;
    var last = get_lastIndex(phases);
    if (inductionVariable <= last)
      $l$loop_0: do {
        var phaseIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = phases.get_c1px32_k$(phaseIndex);
        var tmp0_elvis_lhs = tmp instanceof PhaseContent() ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var phaseContent = tmp_0;
        if (phaseContent.get_isEmpty_zauvru_k$())
          continue $l$loop_0;
        var interceptors = phaseContent.sharedInterceptors_rmg8b1_k$();
        setInterceptorsListFromPhase($this, phaseContent);
        return interceptors;
      }
       while (!(phaseIndex === last));
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var inductionVariable_0 = 0;
  var last_0 = get_lastIndex(phases);
  if (inductionVariable_0 <= last_0)
    $l$loop_1: do {
      var phaseIndex_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp_1 = phases.get_c1px32_k$(phaseIndex_0);
      var tmp1_elvis_lhs = tmp_1 instanceof PhaseContent() ? tmp_1 : null;
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop_1;
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      var phase = tmp_2;
      phase.addTo_219g88_k$(destination);
    }
     while (!(phaseIndex_0 === last_0));
  notSharedInterceptorsList($this, destination);
  return destination;
}
function sharedInterceptorsList($this) {
  if (_get_interceptors__h4min7($this) == null) {
    cacheInterceptors($this);
  }
  $this.interceptorsListShared_1 = true;
  return ensureNotNull(_get_interceptors__h4min7($this));
}
function resetInterceptorsList($this) {
  _set_interceptors__wod97b($this, null);
  $this.interceptorsListShared_1 = false;
  $this.interceptorsListSharedPhase_1 = null;
}
function notSharedInterceptorsList($this, list) {
  _set_interceptors__wod97b($this, list);
  $this.interceptorsListShared_1 = false;
  $this.interceptorsListSharedPhase_1 = null;
}
function setInterceptorsListFromPhase($this, phaseContent) {
  _set_interceptors__wod97b($this, phaseContent.sharedInterceptors_rmg8b1_k$());
  $this.interceptorsListShared_1 = false;
  $this.interceptorsListSharedPhase_1 = phaseContent.phase_1;
}
function tryAddToPhaseFastPath($this, phase, block) {
  var currentInterceptors = _get_interceptors__h4min7($this);
  if ($this.phasesRaw_1.isEmpty_y1axqb_k$() || currentInterceptors == null) {
    return false;
  }
  var tmp;
  if ($this.interceptorsListShared_1) {
    tmp = true;
  } else {
    tmp = !isInterface(currentInterceptors, KtMutableList());
  }
  if (tmp) {
    return false;
  }
  if (equals($this.interceptorsListSharedPhase_1, phase)) {
    currentInterceptors.add_utx5q5_k$(block);
    return true;
  }
  if (equals(phase, last($this.phasesRaw_1)) || findPhaseIndex($this, phase) === get_lastIndex($this.phasesRaw_1)) {
    ensureNotNull(findPhase($this, phase)).addInterceptor_jvll3j_k$(block);
    currentInterceptors.add_utx5q5_k$(block);
    return true;
  }
  return false;
}
function Pipeline$_get_interceptors_$ref_u6zl4e() {
  return constructCallableReference((p0) => _get_interceptors__h4min7(p0), 1, 0, 207);
}
function Pipeline$_set_interceptors_$ref_13vc1m() {
  return constructCallableReference((p0, p1) => {
    _set_interceptors__wod97b(p0, p1);
    return Unit_instance;
  }, 2, 0, 208);
}
var PipelineClass;
function Pipeline() {
  if (PipelineClass === VOID) {
    class $ {
      constructor(phases) {
        this.attributes_1 = AttributesJsFn(true);
        this.developmentMode_1 = false;
        this.phasesRaw_1 = mutableListOf(phases.slice());
        this.interceptorsQuantity_1 = 0;
        this.interceptors$delegate_1 = atomic$ref$1(null);
        this.interceptorsListShared_1 = false;
        this.interceptorsListSharedPhase_1 = null;
      }
      get_developmentMode_eqiro5_k$() {
        return this.developmentMode_1;
      }
      *execute_qsx0hz_k$(context, subject, $completion) {
        // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.get_context_h02k06_k$();
        return yield* createContext(this, context, subject, tmp$ret$0).execute_pc5rz_k$(subject, $completion);
      }
      insertPhaseAfter_gfhxiu_k$(reference, phase) {
        if (hasPhase(this, phase))
          return Unit_instance;
        var index = findPhaseIndex(this, reference);
        if (index === -1) {
          throw new (InvalidPhaseException())('Phase ' + reference.toString() + ' was not registered for this pipeline');
        }
        var lastRelatedPhaseIndex = index;
        var inductionVariable = index + 1 | 0;
        var last = get_lastIndex(this.phasesRaw_1);
        if (inductionVariable <= last)
          $l$loop_0: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.phasesRaw_1.get_c1px32_k$(i);
            var tmp0_safe_receiver = tmp instanceof PhaseContent() ? tmp : null;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.relation_1;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              break $l$loop_0;
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }
            var relation = tmp_0;
            var tmp2_safe_receiver = relation instanceof After() ? relation : null;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.relativeTo_1;
            var tmp_1;
            if (tmp3_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp_1 = tmp3_elvis_lhs;
            }
            var relatedTo = tmp_1;
            lastRelatedPhaseIndex = equals(relatedTo, reference) ? i : lastRelatedPhaseIndex;
          }
           while (!(i === last));
        this.phasesRaw_1.add_dl6gt3_k$(lastRelatedPhaseIndex + 1 | 0, PhaseContent().new_io_ktor_util_pipeline_PhaseContent_24bg4y_k$(phase, new (After())(reference)));
      }
      insertPhaseBefore_rj4han_k$(reference, phase) {
        if (hasPhase(this, phase))
          return Unit_instance;
        var index = findPhaseIndex(this, reference);
        if (index === -1) {
          throw new (InvalidPhaseException())('Phase ' + reference.toString() + ' was not registered for this pipeline');
        }
        this.phasesRaw_1.add_dl6gt3_k$(index, PhaseContent().new_io_ktor_util_pipeline_PhaseContent_24bg4y_k$(phase, new (Before())(reference)));
      }
      intercept_k21bv3_k$(phase, block) {
        var tmp0_elvis_lhs = findPhase(this, phase);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw new (InvalidPhaseException())('Phase ' + phase.toString() + ' was not registered for this pipeline');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var phaseContent = tmp;
        if (tryAddToPhaseFastPath(this, phase, block)) {
          this.interceptorsQuantity_1 = this.interceptorsQuantity_1 + 1 | 0;
          return Unit_instance;
        }
        phaseContent.addInterceptor_jvll3j_k$(block);
        this.interceptorsQuantity_1 = this.interceptorsQuantity_1 + 1 | 0;
        resetInterceptorsList(this);
        this.afterIntercepted_wg8ihh_k$();
      }
      afterIntercepted_wg8ihh_k$() {
      }
      toString() {
        return anyToString(this);
      }
    }
    initMetadataForClass($, 'Pipeline', VOID, VOID, VOID, [2]);
    PipelineClass = $;
  }
  return PipelineClass;
}
//region block: exports
export {
  Pipeline as Pipeline2vw6c5wpzxajt,
};
//endregion

//# sourceMappingURL=Pipeline.mjs.map
